import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const TermsConditionsPage = () => {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />

      <div className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-extrabold text-gray-900 mb-6">Terms &amp; Conditions</h1>
          <p className="text-gray-600 mb-12">Last Updated: January 2025</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Agreement to Terms</h2>
              <p className="text-gray-700 leading-relaxed">
                By accessing and using InfoDrop.in, you accept and agree to be bound by the terms and conditions of this agreement. If you do not agree to these terms, please do not use our website.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Use of Website</h2>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Permitted Use</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                You may use our website for lawful purposes only. You agree not to:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe on intellectual property rights</li>
                <li>Transmit harmful or malicious code</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Use automated systems to access the website without permission</li>
                <li>Impersonate any person or entity</li>
              </ul>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Giveaway Information Disclaimer</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                <strong>Important:</strong> InfoDrop.in is an information platform only. We do not organize, conduct, or sponsor any giveaways ourselves.
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>All giveaway information is provided for educational purposes</li>
                <li>We are not responsible for third-party giveaways</li>
                <li>Participation in any giveaway is at your own risk</li>
                <li>We do not guarantee any rewards or prizes</li>
                <li>Always verify the authenticity of giveaway organizers</li>
              </ul>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">No Affiliation</h2>
              <p className="text-gray-700 leading-relaxed">
                InfoDrop.in is not affiliated with, endorsed by, or connected to Garena, Free Fire, Krafton, BGMI, or any other game developers or publishers. All game names, trademarks, and logos are the property of their respective owners.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Content Accuracy</h2>
              <p className="text-gray-700 leading-relaxed">
                While we strive to provide accurate and up-to-date information, we make no warranties or representations about the accuracy, completeness, or reliability of any content on our website. Information may change without notice.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">User Submissions</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                When you submit information through our forms or contact methods:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>You grant us permission to use the information for stated purposes</li>
                <li>You confirm that the information provided is accurate</li>
                <li>You understand that submissions do not guarantee any rewards</li>
                <li>You agree not to submit false or misleading information</li>
              </ul>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Intellectual Property</h2>
              <p className="text-gray-700 leading-relaxed">
                All content on InfoDrop.in, including text, graphics, logos, and images, is the property of InfoDrop.in or its content suppliers and is protected by copyright laws. You may not reproduce, distribute, or create derivative works without our express written permission.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Third-Party Links</h2>
              <p className="text-gray-700 leading-relaxed">
                Our website may contain links to third-party websites. We are not responsible for the content, privacy practices, or terms of service of these external sites. Accessing third-party links is at your own risk.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Limitation of Liability</h2>
              <p className="text-gray-700 leading-relaxed">
                To the fullest extent permitted by law, InfoDrop.in shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the website, even if we have been advised of the possibility of such damages.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Indemnification</h2>
              <p className="text-gray-700 leading-relaxed">
                You agree to indemnify and hold harmless InfoDrop.in and its affiliates from any claims, damages, losses, liabilities, and expenses arising from your use of the website or violation of these terms.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Changes to Terms</h2>
              <p className="text-gray-700 leading-relaxed">
                We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting. Your continued use of the website after changes constitutes acceptance of the modified terms.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Governing Law</h2>
              <p className="text-gray-700 leading-relaxed">
                These terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Contact Information</h2>
              <p className="text-gray-700 leading-relaxed">
                If you have any questions about these Terms &amp; Conditions, please contact us at:
              </p>
              <p className="text-blue-500 font-semibold mt-4">
                Email: contact@infodrop.in
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsConditionsPage;
